import { Injector } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

// Services
import { AuthService } from '@auth/auth.service';

// Configs
import { COOKIE_ENUMERATION, LOAN_APPLICATION_STATE_ENUMERATION } from '@home/login/configs';

// Types
import { LoanRedirectOptionsType, RedirectionHandlerType, ThirdPartyDetailType } from '../models';

// Environment
import { environment } from '@environments/environment';

export class ThirdPartyRedirectionHandler implements RedirectionHandlerType {
  private readonly authService: AuthService;
  private readonly cookieService: CookieService;

  constructor(private readonly injector: Injector) {
    this.authService = this.injector.get(AuthService);
    this.cookieService = this.injector.get(CookieService);
  }

  public canHandle(options: LoanRedirectOptionsType): boolean {
    const { thirdPartyDetail, loanState } = options;
    return !!thirdPartyDetail && loanState === LOAN_APPLICATION_STATE_ENUMERATION.PENDING_SIGNATURE;
  }

  public handle(options: LoanRedirectOptionsType): void {
    const { thirdPartyDetail, loanState, amount, term } = options;
    this.handleThirdPartyRedirect({ thirdPartyDetail, loanState, amount, term });
  }

  private handleThirdPartyRedirect(options: {
    thirdPartyDetail: ThirdPartyDetailType;
    loanState: LOAN_APPLICATION_STATE_ENUMERATION;
    amount: number;
    term: number;
  }): void {
    const { thirdPartyDetail, loanState, amount, term } = options;

    const params = new URLSearchParams({
      allianceCode: thirdPartyDetail.thirdPartyExternalId,
      status: loanState,
      amount: amount.toString(),
      term: term.toString(),
    });

    this.cookieService.set(COOKIE_ENUMERATION.CRFRAP, this.authService.token, 1, '/', environment.domain);
    window.location.href = `${environment.alliancesUrl}sso?${params.toString()}`;
  }
}
